import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=32664ee2&"
import script from "./shopping-cart.vue?vue&type=script&lang=tsx&"
export * from "./shopping-cart.vue?vue&type=script&lang=tsx&"
import style0 from "./shopping-cart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports